import React from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';

// Own constants/actions/components
import StepsLineComponent from 'components/steps-line';
import ShoppingCartEmpty from 'components/shopping-cart/empty';
import CardShopping from 'containers/shopping-cart/card-shopping';
import { items } from 'services/selectors/shopping-cart';
import { REDIRECT_LOGIN_LINK } from 'constants/Constants';
import ResumenTicketMobile from './resumen-ticket-mobile';

const ShoppingCartContainer = () => {
  const itemsCart = useSelector(items);
  const redirectLogin = () => {
    window.location.href = REDIRECT_LOGIN_LINK;
  };

  const renderBody = () => {
    return (
      itemsCart && itemsCart.length > 0
        ? <CardShopping items={itemsCart} />
        : <ShoppingCartEmpty />
    );
  };

  return (
    <>
      <ResumenTicketMobile resumen={itemsCart} />
      <Container fluid className="bg-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <StepsLineComponent itemActive={1} />
            </Col>
          </Row>
          <Row className="justify-content-center py-60">
            {
              Cookies.get('frontSession') === undefined ? redirectLogin() : renderBody()
            }
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default ShoppingCartContainer;
